// src/pages/About.js
import React from "react";
import styles from "./About.module.css"; // We'll create this CSS module next

function About() {
  return (
    <div className={styles.container}>
      <h1>About Benmed Technologies</h1>
      <p>My name is Ben</p>
      
    </div>
  );
}

export default About;